import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Label } from "recharts";
import styles from "../../_css/MoneySpentPerLanguageChart.module.css";
import { DataLoader } from "../common/ResponseLoader";

const data = [
  { name: "English", value: 35.77 },
  { name: "Arabic", value: 70 },
];
const COLORS = ["#2595D2", "#234A93"];

const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  outerRadius,
  percent,
  index,
}, data) => {
  const RADIAN = Math.PI / 180;
  const offset = 8;
  const lineLength = 18;
  const angle = -midAngle * RADIAN;
  const radius = outerRadius - 10;
  const sx = cx + radius * Math.cos(angle);
  const sy = cy + radius * Math.sin(angle);
  const ex = cx + (radius + offset + lineLength) * Math.cos(angle);
  const ey = cy + (radius + offset + lineLength) * Math.sin(angle);
  const lx = cx + (radius + offset + lineLength) * Math.cos(angle);
  const ly = cy + (radius + offset + lineLength) * Math.sin(angle);
  return (
    <g>
      <line x1={sx} y1={sy} x2={ex} y2={ey} stroke="#E5E7EB" strokeWidth={2} />
      <text
        x={lx}
        y={ly}
        fill={COLORS[index]}
        fontSize={22}
        fontWeight={700}
        textAnchor={lx > cx ? "start" : "end"}
        dominantBaseline="central"
      >
${data[index].value.toFixed(4)}
      </text>
    </g>
  );
};

const MoneySpentPerLanguageChart = ({ data }) => (
  <div className={styles.card}>
    <h3 className={styles.title}>Money Spent per Language</h3>
    {data?.length > 0 ? (
      <>
        <ResponsiveContainer width="100%" height={240}>
          <PieChart>
            <Pie
              data={data || []}
              cx="50%"
              cy="50%"
              outerRadius={90}
              startAngle={90}
              endAngle={-270}
              dataKey="value"
              labelLine={false}
              label={(props) => renderCustomizedLabel(props, data)}
            >
              {data?.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index]} />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
        <div className={styles.legendRow}>
          <span
            className={styles.legendDot}
            style={{ background: COLORS[1] }}
          />{" "}
          {data[1].name}
          <span
            className={styles.legendDot}
            style={{ background: COLORS[0], marginLeft: 24 }}
          />{" "}
          {data[0].name}
        </div>
      </>
    ) : (
      <DataLoader />
    )}
  </div>
);

export default MoneySpentPerLanguageChart;
